var UpdatedModelVoData = /** @class */ (function () {
    function UpdatedModelVoData(uid, updatesData) {
        this.uid = uid;
        this.updatesData = updatesData;
    }
    return UpdatedModelVoData;
}());
export { UpdatedModelVoData };
//# sourceMappingURL=updated-model-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/model/updated-model-vo-data.js
// module id = 909
// module chunks = 14